module.exports = __webpack_public_path__ + "img/11-half-lg.1382a71d.jpg";